export const advantagesInfo = [
  {
    number: 1,
    advantage: "직장 병행 가능",
    desc: "평일 퇴근 이후와 주말을 활용해 100% 온라인으로 수강하는 부트캠프입니다. 기존 커리어를 포기하지 않으셔도 됩니다.",
  },
  {
    number: 2,
    advantage: "실전을 그대로 담은 커리큘럼",
    desc: "SW캠프는 이론 주입형이 아닙니다. 실패도 성취도 직접 해보면서 ‘내 실력으로 만든 나만의 이야기’를 갖추실 수 있도록 돕겠습니다.",
  },
  {
    number: 3,
    advantage: "현직 실무자 멘토",
    desc: "현직 4-10년차 멘토가 실무에서 경험한 것을 과제로, 피드백으로 나눠드립니다. 현업에서 실력으로 인정받는 멘토의 밀착 코칭을 받으며 성장하세요.",
  },
];
